// src/context/DashboardKindContext.tsx
//
// The kind of the row on screen, for the words only (plan 2026-10-26, D9).
// Insights wraps the page in the provider; any component under it that has
// user-visible copy naming the dashboard or its tabs reads `useKindCopy()`
// instead of being handed a `kind` prop through four layers. Outside the
// provider (a test mounting one section, the dashboards overview) the kind
// is a dashboard, so nothing that does not opt in changes.
import { createContext, useContext, type ReactNode } from "react";
import type { DashboardKind } from "@/api/dashboards";
import { kindCopy, type KindCopy } from "@/utils/kindCopy";

const DashboardKindContext = createContext<DashboardKind | undefined>(undefined);

export function DashboardKindProvider({
  kind,
  children,
}: {
  kind: DashboardKind | undefined;
  children: ReactNode;
}) {
  return <DashboardKindContext.Provider value={kind}>{children}</DashboardKindContext.Provider>;
}

export function useKindCopy(): KindCopy {
  return kindCopy(useContext(DashboardKindContext));
}
